import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  constructor() { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes(environment.photosAPI) || request.url.includes('news')) {
      return next.handle(request);
    }
    const req = request.clone({
      headers: request.headers.append("Client-Security-Token",
        "8a9aeaee-69b6-4d7b-81fa-8ca3f93adb6c")
    })
    return next.handle(req);
  }
}
